// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2m7hr","activeHandle":"RangeSlider_activeHandle__1a19l"};